module.exports = __webpack_public_path__ + "img/05-title-01.ada3fcda.png";